<template>
    <div>
        <div class="leaderBox" v-if="showOrhide1">
            <div class="newtext">新手指引</div>
            <img src="../../../assets/images/maskClose.png" class="closeIt" @click="closeIt1">
            <img src="../../../assets/images/xqgl1.png" class="steps step4" v-if="status1==1">
            <img src="../../../assets/images/xqgl2.png" class="steps step5" v-if="status1==2">
            <img src="../../../assets/images/xqgl3.png" class="steps step6" v-if="status1==3">
            <img src="../../../assets/images/xqgl4.png" class="steps step7" v-if="status1==4">
            <div class="stepbtn" @click="nextStep1(status1)">
                {{status1==1?"下一步":status1==2?"下一步":status1==3?"下一步":status1==4?"我知道了":"我知道了"}}
            </div>
            <div class="bottomTip">
                <el-checkbox v-model="checked1">下次不再提示</el-checkbox>
            </div>
        </div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'考勤报表'}]"/>-->
      <Breadtabsheader/>
        <div style="margin:20px">
            <div class="h-piece">
                <div class="h-formBox">
                    <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                        <div class="h-thirdColumn w-newColumn">
                          <!--<el-form-item label="区域">-->
                          <!--  <brselect v-model="q.quyuCode" :v="q.quyuCode" category="BIGRegion" :clearable="true"></brselect>-->
                          <!--</el-form-item>-->
                          <el-form-item label="区域" >
                            <el-select filterable v-model="q.area" clearable placeholder="请选择" >
                              <el-option
                                  v-for="(item,index) in quyuList"
                                  :key="item+index"
                                  :label="item"
                                  :value="item">
                              </el-option>
                            </el-select>
                          </el-form-item>
                            <el-form-item label="提报人">
                                <el-input v-model="q.usercode" placeholder="请输入提报人工号或名称"></el-input>
                            </el-form-item>
                            <el-form-item label="链群">
                                <el-input v-model="q.lianqunCode" placeholder="请输入链群编码或名称"></el-input>
                            </el-form-item>
                            <el-form-item label="月份" prop="taskEnddate">
                                <div class="block">
                                    <el-date-picker
                                            v-model="q.businessTime"
                                            type="month"
                                            placeholder="选择月"
                                            value-format="yyyy-MM">
                                    </el-date-picker>
                                </div>
                            </el-form-item>
                        </div>
                      <div class="h-thirdColumn w-newColumn">
                        <el-form-item label="部门">
                          <el-select filterable v-model="q.cdept" clearable placeholder="请选择"
                          >
                            <el-option
                                v-for="(item,index) in deptList"
                                :key="item.dept"
                                :label="item.dept"
                                :value="item.dept">
                            </el-option>
                          </el-select>
                        </el-form-item>
                      </div>
                    </el-form>
                    <div class="l-screenBox">
                        <div class="l-retrieval">
                            <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                            <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="h-table h-mrt30">
<!--                <div class="h-rowIn" style="width: 100%;">-->
<!--                    <div style="height: 7.3rem;overflow: hidden;position: relative;">-->
<!--                        <div class="h-rowBox" style="border-bottom: none;box-shadow: none;">-->
                            <el-table
                                    v-if="tableLoadStatus"
                                    ref="ddtable"
                                    :data="tableData"
                                    :border="true"
                                    stripe
                                    style="width: 100%">
                                <el-table-column
                                        type="index"
                                        label="#" width="40">
                                </el-table-column>
                                <el-table-column
                                        prop="usercode"
                                        label="工号"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="username"
                                        label="姓名"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="lianqun_name"
                                        label="链群"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="area"
                                    label="区域"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="cdept"
                                    label="部门"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="year"
                                        label="年"
                                >
                                </el-table-column>
                                <el-table-column
                                        prop="month"
                                        label="月"
                                        :show-overflow-tooltip="true"
                                >
                                </el-table-column>
                                 <el-table-column
                                        prop="notRqCount"
                                        label="未清合计"
                                        :show-overflow-tooltip="true"
                                >
                                </el-table-column>
                                <!-- 遍历T+3到T+13周周列信息,分多级表头,第一级表头是周信息,第二级表头为周包含日信息 -->
                                <template v-for="(column, index) in dayInfoList">
                                    <el-table-column
                                        v-bind="column"
                                        :label="column.day"
                                        :prop="column.day"
                                        :key="column.id"
                                    >
                                        <template slot="header" scope="scope">
                                           <span v-headred="column.weekFlag" :style="getColor(column)">{{column.day}}</span>
                                        </template>
                                        <template scope="scope">
                                            <span v-if="scope.row[column.day]  == '0' && column.weekFlag == false ">
                                                缺勤
                                            </span>
                                            <span v-if="scope.row[column.day]  == '1' ">
                                                正常
                                            </span>
                                            <span v-if="scope.row[column.day]  == '2' ">
                                                不考核
                                            </span>
                                        </template>
                                    </el-table-column>
                                </template>

                            </el-table>
                        </div>
                        <div class="h-tableB h-mrt30">
                            <div class="h-tableBL">
                                <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                                           @click="exportRqExcel()">批量导出
                                </el-button>
                            </div>
                            <div class="h-pagination2">
                                <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
                            </div>
<!--                        </div>-->
<!--                    </div>-->
<!--                </div>-->
            </div>
        </div>
    </div>
</template>

<script>
    import ss from '../../../api/SystemService'
    import updownfile from '../../../utils/updownfile'
    import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'

    export default {
        components: {
            uploaddownexcel,
        },
        data() {
            return {
                q: {
                    businessTime: this.dateFormatter(new Date(),false),
                    usercode: '',
                    lianqunCode: '',
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    quyuCode: '',
                    area: '',
                    cdept: '',

                },
                monthTime: new Date(),
                tablelist: [],
                tableName: {},
                tableData: [],
                LevelName: [],
                deptList: [],
                quyuList: [],
                mDate:'',
                qdetail: {
                    id: null,
                    demandType: null,
                    customer: {
                        areaCode: null,
                    }
                },
                dayInfoList: [],
                tableLoadStatus: false
            }
        },
        beforeRouteLeave(to, from, next) {
            from.meta.keepAlive = false;
            next();
        },
        activated(){
            this.query();
        },
        methods: {
            //重置检索项
            resetData() {
                this.q.usercode = null;
                // this.q.businessTime = null;
                this.q.lianqunCode = null;
                this.q.quyuCode = null;
                this.q.cdept = null;
            },
            //检索
            handleFilter(query) {
                this.query();
                this.getMonthDayList();
            },
            //表格
            query() {
                ss.riqingRep.selectRepPage(this.q).then(rd => {
                    this.q.total = rd.msg.total;
                    this.tableData = rd.msg.records;
                    this.tableLoadStatus = true;
                });
            },
          getDept(q){
            ss.MuBiao.getDeptList(q).then(rd => {
              this.deptList = rd;
            })
          },
          getQuyu(q){
            ss.MuBiao.getQuyuList(q).then(rd => {
              console.log("area",rd)
              this.quyuList = rd;
            })
          },
            getMonthDayList(){

                ss.riqingRep.getMonthDayList(this.q).then(rd => {
                    this.tableLoadStatus = false;
                    this.dayInfoList = rd.msg.map(item => {
                        return {id: item.day + this.q, ...item}
                    });
                    this.tableLoadStatus = true;
                    console.log("day",this.dayInfoList);
                });
            },
            dateFormatter(str){//默认返回yyyy-MM-dd HH-mm-ss
                var hasTime = arguments[1] != false ? true : false;//可传第二个参数false，返回yyyy-MM-dd
                var d = new Date(str);
                var year = d.getFullYear();
                var month = (d.getMonth()+1)<10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1);
                var day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
                var hour = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
                var minute = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
                var second = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();
                console.log("日期",[year, month].join('-'))
                return [year, month].join('-');
            },
            exportRqExcel(item){
                ss.riqingRep.downloadBatchExcel(this.q).then(res => { // 处理返回的文件流
                    const link = document.createElement('a')
                    let blob = new Blob([res],{type: 'application/vnd.ms-excel'});
                    link.style.display = 'none'
                    link.href = URL.createObjectURL(blob);
                    link.setAttribute('download', `考勤报表导出详情.xlsx`)
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)
                }).catch(function (error) {
                    console.log("导出错误",error.toString())
                });
            },
            getColor(colunm){
                console.log(colunm.day, colunm.weekFlag)
                if(colunm.weekFlag == true || colunm.weekFlag == 'true'){
                    return {color: '#fff'}
                }else {
                    return {color: '#fff'}
                }
            }
        },
        created() {
            this.getMonthDayList();
            this.query();
            this.getDept();
            this.getQuyu();
        },
        mounted() {

        },
        directives: {
            headred: {
                inserted: function (el, binding, vnode) {
                    if(binding.value){
                        el.parentNode.parentNode.style = "background: orange;color: #fff"
                    }else{
                        el.parentNode.parentNode.style = ""
                    }
                },
                update: function (el, binding, vnode) {
                    if(binding.value){
                        el.parentNode.parentNode.style = "background: orange;color: #fff"
                    }else{
                        el.parentNode.parentNode.style = ""
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .cuname {
        font-size: 0.16rem;
        color: #323232;
    }

    .selectbbbb {
        display: flex;
        align-items: center;
        border-bottom: 2px solid #f9f9f9;
    }

    .selectbbbb:hover {
        background: #f5fcff;
    }

    .h-gaugePieLegend .h-gpLegendLi i {
        margin-top: -12px;
    }

    .totals {
        text-align: center;
        font-size: 0.22rem;
        color: #282828;
        margin-bottom: 20px;
    }


    .h-formLines {
        padding: 30px 48px;
    }

    .xuqiuBoxList {
        width: 100%;
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }

    .xuqiuBoxList .xuqiulist {
        width: 200px;
        height: 62px;
        border-radius: 4px;
        background: #fff;
        border: 1px solid #959595;
        text-align: center;
        line-height: 62px;
        color: #989898;
        cursor: pointer;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
    }

    .xuqiuBoxList .xuqiulist:first-child {
        margin-left: 0
    }

    .xuqiuBoxList .xuqiulist.active {
        background: #238cfd;
        border: 1px solid #238cfd;
        color: #fff;
    }

    .xuqiutext {
        color: #bcbcbc;
        font-size: 14px;
        margin-bottom: 14px;
    }
</style>
<style>
    .selectcheckbox .el-checkbox:hover {
        background: 0
    }

    .selectcheckbox .el-checkbox {
        margin-bottom: 5px
    }

    .selectcheckbox .el-checkbox__label {
        display: none
    }

    .h-dialogForm .h-elformWrap-3 .el-form-item__label:first-child {
        width: 23%;
    }

    .h-dialogForm .h-elformWrap-3 .el-form-item__content {
        width: 70%;
    }

    .el-form-item__content .secondX {
        position: absolute;
        top: 0;
        left: -89px;
        color: red;
        font-size: 0.2rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body {
        padding: 0 0.5rem 0.3rem 0.5rem;
    }

    .h-dialog3.dialogFormVisible3 .el-dialog__body .el-upload--picture-card {
        width: 100%;
        height: 103px;
        border: 1px dashed #7c9ec0;
        background: 0;
        line-height: 103px;
        margin-top: 20px;
        color: #4b4b4b;
        font-size: 18px;
    }

    .fenyes .el-pagination .el-pagination__sizes {
        display: none;
    }

    .h-formBorder .timeselect .el-date-editor .el-range-separator {
        width: 8%;
        line-height: 28px;
    }

    .h-formBorder .timeselect .el-input__inner {
        padding-right: 0.1rem;
    }

    .timeselect .el-date-editor.el-input__inner {
        width: 3.5rem;
    }

    .ljjtablesdata.el-table tbody td:first-child{
        border-left: 0;
    }
    .ljjtablesdata.el-table tbody td:first-child{
        border-right: 1px solid #EBEEF5;
    }
    .ljjtablesdata.el-table tbody td:nth-child(2){
        border-right: 1px solid #EBEEF5;
    }
    .ljjtablesdata.el-table tbody td{
        border-right: 0;
    }
    .ljjtablesdata.el-table thead{
        color: #323232;
    }
    .ljjtablesdata.el-table thead tr{
        /*background-color: rgba(255,0,0,0.5);*/
        background-color: #f5fcff;
    }
    .ljjtablesdata.el-table thead th{
        background: #f5fcff;
    }
    .ljjtablesdata.el-table .warning-row {
        background: #f5fcff;
    }
    .ljjtablesdata.el-table .zfenleis{
        padding: 0.05rem;
        background: #fce0b7;
        color: #d99a4b;
        margin-right: 0.05rem;
    }
    .ljjtablesdata.el-table .zfenleis:nth-child(2){
        background: #d1e4ff;
        color: #006ccf;
    }
    .ljjtablexuqius .el-table tbody td .cell{
        padding: 0.1rem;
    }
</style>
<style scoped lang="scss">
    .bottomTip {
        position: absolute;
        left: 49.7%;
        bottom: 0.3rem;
        transform: translateX(-50%);
    }

    .newtext {
        font-size: 0.28rem;
        color: white;
        position: absolute;
        top: 0.2rem;
        left: 50%;
        transform: translateX(-50%);
        font-weight: bold;
        text-shadow: 1px 1px 4px #2785E7;
        z-index: 2;
    }

    .leaderBox {
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.4);
        position: fixed;
        z-index: 99999;
        overflow: hidden;
        top: 0;
        left: 0;

        .leaderbg {
            width: 100%;
            height: 100%;
        }

        .steps {
            position: absolute;
            z-index: 1;
        }

        .step4 {
            top: 0.8rem;
            left: 0rem;
            width: 6.6rem;
            height: 15rem;
        }

        .step5 {
            top: 2.2rem;
            right: 1.35rem;
            width: 4.7rem;
            height: 1rem;
        }

        .step6 {
            top: 2.28rem;
            left: 2.6rem;
            width: 9.2rem;
            height: 12rem;
        }

        .step7 {
            top: 3.45rem;
            right: 0.2rem;
            width: 6.9rem;
            height: 12rem;
        }

        .stepbtn {
            width: 1.9rem;
            height: 0.6rem;
            border: 0.03rem solid #FFFFFF;
            background-color: rgba(0, 0, 0, 0.1);
            border-radius: 5px;
            display: flex;
            justify-content: center;
            line-height: 0.5rem;
            position: absolute;
            z-index: 99;
            bottom: 0.75rem;
            left: 50%;
            transform: translateX(-50%);
            font-size: 0.27rem;
            letter-spacing: 2px;
            color: white;
            cursor: pointer;
        }

        .closeIt {
            width: 0.3rem;
            height: 0.3rem;
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            cursor: pointer;
        }
    }
</style>
